import itemId from 'owa-service/lib/factory/itemId';
/**
 * Get the ItemIds in the specified conversations
 * @param itemIdsToUpdate an array of item id strings
 * @return an array of ItemIds for EWS service request
 */
export default function getServiceItemIds(itemIdsToUpdate) {
    var itemIds = itemIdsToUpdate.map(function (id) { return itemId({ Id: id }); });
    return itemIds;
}
//# sourceMappingURL=getServiceItemIds.js.map